import React, { useState, useEffect } from 'react';
import { Coffee, BookOpen, Moon, Headphones, Zap, Gamepad2, Disc3, TrendingUp } from 'lucide-react';

// Generate 56 unique placeholder URLs
const totalPlaylistsRequired = 8 * 7; // 8 vibes, 7 playlists each
const zenithFlowPlaylists = [
  'https://open.spotify.com/embed/playlist/1GUzTiJWK1Jg5sNIoYqdGD?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/7t8jQE7HYNgm0cezyVXnxX?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/2i491CgDo4oPVNNR9dWEAD?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/3rkImUGwBzZ4EVUJxyHMJe?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/74sUjcvpGfdOvCHvgzNEDO?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/6jrrCrrx8TtXMkegxPXpn1?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/5ZQQXzXB5nYOq3l65Nu9Zi?utm_source=generator&theme=0'
];

// Playlists for Mind Palace
const mindPalacePlaylists = [
  'https://open.spotify.com/embed/playlist/6wObnEPQ63a4kei1sEcMdH?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/6rtLAwHvK7YSX08Y16EjLG?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/6Lu6axWZfzpqiZaw4esuhO?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/69yQZRKZjbyUcViKnaL4Mp?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/37i9dQZF1DWZeKCadgRdKQ?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/0p8kH215jUmS3Au2npP7gY?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/0VAxF4683V4LH0YFyHvVqq?utm_source=generator&theme=0'
];

// Playlists for Neon Pulse
const neonPulsePlaylists = [
  'https://open.spotify.com/embed/playlist/3ebHKSjHujS4Tyt2KKP97R?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/72QcDj6ZRP30vyKYQQuvYF?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/5PDbeCwCxoxy3Y6x0N1yXp?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/37i9dQZF1EIe5yQtq6awlo?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/40kgD7WfIH4rELyupZVAav?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/3tM9imYaRc3AtwY3VGDIkh?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/2NdjM96zjT15naXZPOo44u?utm_source=generator&theme=0'
];

// Playlists for Dream Weave
const dreamWeavePlaylists = [
  'https://open.spotify.com/embed/playlist/2BkI5XZ228Uwcf8FzQMcMX?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/3EAX0kaQDMRwfZZGoV02GT?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/4ANvRT2kppEoBvMDpupi9m?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/5eGq8oZUQmrMmkGjcGyYhq?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/3yPrVufcauWkFQ8Oc01DGx?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/4SwdIZAcV5fKtkqbwGMDmi?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/5ERlHCex68iL4VTNa9qN4q?utm_source=generator&theme=0'
];

// Playlists for Rhythm Glitch
const rhythmGlitchPlaylists = [
  'https://open.spotify.com/embed/playlist/5yNAwIqxnUDlqvecX9vngZ?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/3dCxqOX3j0FtCavbLQec4N?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/3vCLLSzMJzkethkFbLfzmx?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/37i9dQZF1EIcFz8RaZLYnr?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/37i9dQZF1EIcAwxZPjqY87?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/2PUdNbjXpTxBZee4fG7s23?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/2Ir5MP20VzC5Aj62CBd2xW?utm_source=generator&theme=0'
];

// Playlists for Pixel Quest
const pixelQuestPlaylists = [
  'https://open.spotify.com/embed/playlist/51GgYecliIOWoscUztVt0l?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/0JxINaXnAw42dyFmLHCuxn?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/6Fgivh03skKL3oAbGWg9Yt?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/37i9dQZF1DXdfOcg1fm0VG?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/0naQH6utqKcAnO6RxZQ9Km?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/2GiBOXJcq3i88DYwDe2fmC?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/6iJErFM8V7ZYhWXR2LRoiK?utm_source=generator&theme=0'
];

// Playlists for Indie Bloom
const indieBloomPlaylists = [
  'https://open.spotify.com/embed/playlist/30Zp2r5erHeBJNQi1boSij?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/2NCUfWgfP0k8tzTqESdf3r?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/33RsFCcMzdtSD3rNNeFqmR?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/434gEpsArMsVNT0QltbGGc?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/3oqK4QvwUBgTQ0lNpNef0S?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/6i0kOJ1KWahQIRSwWr3mOo?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/37i9dQZF1EIeJWgjsaSSDt?utm_source=generator&theme=0'
];

// Playlists for Hype Stream
const hypeStreamPlaylists = [
  'https://open.spotify.com/embed/playlist/0dMnTH0pRi2siKJ4FLA6KZ?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/3VqsbpAwoAZu3KkYI55GYd?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/1aovscafaunbOayAHuwXy1?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/3I5PiqsI5OQh83gbG6PRJH?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/2luyP7utZXnAkdV5QYTkvZ?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/5NwhekjSTBJGf7uDXCxSjg?utm_source=generator&theme=0',
  'https://open.spotify.com/embed/playlist/37i9dQZF1EIhSskk1NQ9dI?utm_source=generator&theme=0'
];

// All playlists are now defined, so this array will be empty if totalPlaylistsRequired is 56.
// If totalPlaylistsRequired is ever increased, this will generate placeholders for the new vibes.
const remainingVibesPlaceholderPlaylists = Array.from({ length: Math.max(0, totalPlaylistsRequired - 56) }, (_, i) => {
  const vibeIndex = Math.floor((i + 56) / 7); // Start after the first eight vibes
  const playlistInVibeIndex = (i + 56) % 7;
  // Ensure vibeNames array is long enough if new vibes are added beyond the initial 8
  const vibeNames = ['zenithflow', 'mindpalace', 'neonpulse', 'dreamweave', 'rhythmglitch', 'pixelquest', 'indiebloom', 'hypestream', 'newvibe9', 'newvibe10']; // Add more as needed
  return `https://open.spotify.com/embed/playlist/placeholder_${vibeNames[vibeIndex] || 'unknownvibe'}_${playlistInVibeIndex + 1}`;
});

const allUniquePlaceholderPlaylists = [
  ...zenithFlowPlaylists,
  ...mindPalacePlaylists,
  ...neonPulsePlaylists,
  ...dreamWeavePlaylists,
  ...rhythmGlitchPlaylists,
  ...pixelQuestPlaylists,
  ...indieBloomPlaylists,
  ...hypeStreamPlaylists,
  ...remainingVibesPlaceholderPlaylists
];

const vibesData = [
  {
    id: 'dream-weave', name: 'Dream Weave',
    playlistUrls: allUniquePlaceholderPlaylists.slice(21, 28),
    icon: <Headphones size={18} />
  },
  {
    id: 'neon-pulse', name: 'Neon Pulse',
    playlistUrls: allUniquePlaceholderPlaylists.slice(14, 21),
    icon: <Moon size={18} />
  },
  {
    id: 'rhythm-glitch', name: 'Rhythm Glitch',
    playlistUrls: allUniquePlaceholderPlaylists.slice(28, 35),
    icon: <Zap size={18} />
  },
  {
    id: 'zenith-flow', name: 'Zenith Flow',
    playlistUrls: allUniquePlaceholderPlaylists.slice(0, 7),
    icon: <Coffee size={18} />
  },
  {
    id: 'mind-palace', name: 'Mind Palace',
    playlistUrls: allUniquePlaceholderPlaylists.slice(7, 14),
    icon: <BookOpen size={18} />
  },
  {
    id: 'pixel-quest', name: 'Pixel Quest',
    playlistUrls: allUniquePlaceholderPlaylists.slice(35, 42),
    icon: <Gamepad2 size={18} />
  },
  {
    id: 'indie-bloom', name: 'Indie Bloom',
    playlistUrls: allUniquePlaceholderPlaylists.slice(42, 49),
    icon: <Disc3 size={18} />
  },
  {
    id: 'hype-stream', name: 'Hype Stream',
    playlistUrls: allUniquePlaceholderPlaylists.slice(49, 56),
    icon: <TrendingUp size={18} />
  },
];

const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

function App() {
  const [activeVibeId, setActiveVibeId] = useState(vibesData[0].id);
  const [selectedDay, setSelectedDay] = useState(days[new Date().getDay() === 0 ? 6 : new Date().getDay() -1]); // Default to current day
  const [currentPlaylistUrl, setCurrentPlaylistUrl] = useState('');

  const getRandomPlaylist = (playlistArray) => {
    if (!playlistArray || playlistArray.length === 0) return '';
    const randomIndex = Math.floor(Math.random() * playlistArray.length);
    return playlistArray[randomIndex];
  };

  useEffect(() => {
    const currentVibe = vibesData.find(vibe => vibe.id === activeVibeId);
    if (currentVibe && currentVibe.playlistUrls) {
      setCurrentPlaylistUrl(getRandomPlaylist(currentVibe.playlistUrls));
    }
  }, [activeVibeId, selectedDay]); // Re-select playlist if vibe or day changes

  const handleVibeClick = (vibeId) => {
    setActiveVibeId(vibeId);
    // No need to call setCurrentPlaylistUrl here, useEffect will handle it
  };

  const handleDayClick = (day) => {
    setSelectedDay(day);
    // No need to call setCurrentPlaylistUrl here, useEffect will handle it
  };

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>Echo Vibes</h1>
      </header>

      <div className="day-selector-container">
        {days.map((day) => (
          <button
            key={day}
            className={`day-button ${selectedDay === day ? 'active' : ''}`}
            onClick={() => handleDayClick(day)}
          >
            {day}
          </button>
        ))}
      </div>
      
      <div className="vibe-selector-container">
        {vibesData.map((vibe) => (
          <button
            key={vibe.id}
            className={`vibe-button ${activeVibeId === vibe.id ? 'active' : ''}`}
            onClick={() => handleVibeClick(vibe.id)}
          >
            {vibe.icon}
            <span>{vibe.name}</span>
          </button>
        ))}
      </div>

      {currentPlaylistUrl && (
        <div className="spotify-embed-container">
          <iframe
            key={currentPlaylistUrl + selectedDay} // Important: Re-render if URL or day changes to force reload
            style={{ borderRadius: '12px' }}
            src={currentPlaylistUrl}
            width="100%"
            height="352"
            allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          ></iframe>
        </div>
      )}
      <div style={{ textAlign: 'center', fontSize: '0.8em', color: '#999', marginTop: '45px', marginBottom: '15px', fontFamily: 'Montserrat, sans-serif' }}>
        Vibe’s off? Blame the bot 🤖 — playlist picked randomly 😜
      </div>
      <footer className="app-footer">
        Echo Vibes, inside EchoBox &middot; via synthz
      </footer>
    </div>
  );
}

export default App;
